import React from "react";
import {LoginForm} from "../components/login";

export const LoginPage: React.FC = () => <LoginForm/>;
